import React from "react"
import PropTypes from "prop-types"

const Panel = props => {
  const { children } = props
  return <div>{children}</div>
}

export { Panel }

Panel.propTypes = {
  children: PropTypes.shape({}).isRequired
}
